<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <md-card style="height: 100vh">
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousVendorView">&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h3>
              <b>{{ editVar.FormVal }} Service Estimation</b>
            </h3>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />

        <b-row>
          <b-col md="2">
            <label>Estimation Date</label>
            <date-picker :format="selectDateFormat" lang="en" v-model="serviceDetails.serviceEstimationDate"
              :disabled="checkStatus" id="Date"></date-picker>
            <span class="error" v-if="!serviceDetails.serviceEstimationDate">{{
              serviceEstimationDateError
              }}</span>
          </b-col>

          <b-col md="3">
            <label>Supervisor Name</label>
            <b-form-input :formatter="capitalizeAll" id="requestedBy" name="requestedBy"
              v-model="serviceDetails.requestedBy" :disabled="true"></b-form-input>
          </b-col>

          <b-col md="2">
            <label for="maintenanceType">Select Maintenance Type</label>
            <model-list-select :list="MaintainList" :isDisabled="serviceDetails.serviceEstimationId != ''"
              v-model="serviceDetails.maintenanceType" option-value="MVal" option-text="MText" placeholder="Select Type"
              @selected="hideVehicle()" @input="emptyVehicleDetails()"></model-list-select>
            <span class="error" v-if="!serviceDetails.maintenanceType">{{
              maintenanceTypeError
              }}</span>
          </b-col>

          <b-col md="2" v-if="
              serviceDetails.maintenanceType == 'Vehicle' &&
              serviceDetails.serviceEstimationId == ''
            ">
            <label for="maintenanceType">Select Vehicle</label>
            <model-list-select :list="vehicleMasterList" :isDisabled="checkStatus" v-model="VehicleAuto"
              option-value="vehicleTruckId" option-text="regdNo" placeholder="Select Vehicle "
              @input="emptyOdometerReading()"></model-list-select>
          </b-col>

          <b-col md="2" v-if="
              serviceDetails.maintenanceType == 'Vehicle' &&
              serviceDetails.serviceEstimationId != ''
            ">
            <label>Vehicle No.</label>
            <b-form-input :formatter="capitalizeAll" id="vehicleNo" name="vehicleNo" v-model="serviceDetails.vehicleNo"
              disabled></b-form-input>
          </b-col>

          <b-col md="2" v-if="serviceDetails.maintenanceType == 'Yard'" class="ml-4" md-flex="10">
            <label>Vehicle No.</label>
            <b-form-input :formatter="capitalizeAll" id="vehicleYard" name="vehicleYard"
              v-model="serviceDetails.vehicleYard" :disabled="checkStatus"></b-form-input>
          </b-col>

          <b-col md="2" v-if="serviceDetails.maintenanceType == 'Vehicle'">
            <label>Odometer Reading</label>
            <b-form-input :formatter="capitalizeAll" id="odometre_Reading" name="odometre_Reading" type="number" min="0"
              v-model="serviceDetails.odometre_Reading"
              :disabled="serviceDetails.serviceEstimationId != ''"></b-form-input>
            <span class="error" v-if="!serviceDetails.odometre_Reading">{{
              odometreReadingError
              }}</span>
          </b-col>

          <b-col md="4" v-if="serviceDetails.maintenanceType == 'Vehicle'">
            <label>Driver Complain</label>
            <b-form-textarea :formatter="capitalizeAll" id="driver_complain" name="driver_complain"
              v-model="serviceDetails.driver_complain"></b-form-textarea>
          </b-col>

          <b-col md="2" v-if="serviceDetails.maintenanceType == 'Vehicle'">
            <label for="maintenanceType">Nature of Job</label>
            <model-list-select :list="jobNatureList" v-model="serviceDetails.job_nature" option-value="natureVal"
              option-text="natureText" placeholder="Select Job Nature"></model-list-select>
            <span class="error" v-if="!serviceDetails.job_nature">{{
              job_natureError
              }}</span>
          </b-col>
        </b-row>

        <b-row class="mt-3" v-if="serviceDetails.maintenanceType == 'Vehicle'">
          <b-col md="2">
            <label>Engine No.</label>
            <b-form-input :formatter="capitalizeAll" id="engineNo" name="engineNo" v-model="serviceDetails.engineNo"
              :disabled="serviceDetails.maintenanceType == 'Yard' ? checkStatus : true"></b-form-input>
          </b-col>

          <b-col md="3">
            <label>Chassis No.</label>
            <b-form-input :formatter="capitalizeAll" id="chassisNo" name="chassisNo" v-model="serviceDetails.chassisNo"
              :disabled="serviceDetails.maintenanceType == 'Yard' ? checkStatus : true"></b-form-input>
          </b-col>

          <b-col md="2">
            <label>Purchase Year</label>
            <b-form-input :formatter="capitalizeAll" id="yearOfPurchase" name="yearOfPurchase"
              v-model="serviceDetails.yearOfPurchase"
              :disabled="serviceDetails.maintenanceType == 'Yard' ? checkStatus : true"></b-form-input>
          </b-col>

          <b-col md="2">
            <label>Driver Name</label>
            <b-form-input :formatter="capitalizeAll" id="driverName" name="driverName"
              v-model="serviceDetails.driverName"
              :disabled="serviceDetails.maintenanceType == 'Yard' ? checkStatus : true"></b-form-input>
          </b-col>

          <b-col md="2" v-if="serviceDetails.serviceEstimationId != ''">
            <b-button @click="showVehicleHistory(serviceDetails.vehicleTruckId, 'Normal')" style="margin-top: 16%"
              variant="primary" id="vehicleHistoryButton" size="sm">
              Show vehicle History
            </b-button>
          </b-col>
        </b-row>

        <b-row class="mt-4 ml-2" v-if="
            (serviceDetails.approvedStatus == 'Pending' ||
              serviceDetails.approvedStatus == 'Rejected' ||
              serviceDetails.approvedStatus == '') &&
            serviceDetails.onRejectStatus != '3'
          ">
          <hr class="hr-border" />
          <h4 class="mt-2">
            <b>{{ itemModal.itemForServiceEstId == "" ? "Add" : "Edit" }} Items</b>
          </h4>
        </b-row>

        <b-row v-if="
            (serviceDetails.approvedStatus == 'Pending' ||
              serviceDetails.approvedStatus == 'Rejected' ||
              serviceDetails.approvedStatus == '' ||
              ((serviceDetails.approvedStatus == 'Sent For Approval' ||
                serviceDetails.approvedStatus == 'on_Hold') &&
                userLevel == '1')) &&
            serviceDetails.onRejectStatus != '3'
          ">
          <b-col md="2" v-if="itemModal.itemForServiceEstId == ''">
            <label for="itemMasterList">Item Name - Part Number</label>
            <!-- {{itemAuto}} -->
            <model-list-select :list="itemMasterList" :disabled="itemModal.itemForServiceEstId != ''" v-model="itemAuto"
              option-value="itemId" option-text="displayList" placeholder="Select Item"></model-list-select>
            <span class="error" v-if="!itemModal.itemCode">{{ itemCodeError }}</span>
          </b-col>

          <b-col md="2">
            <label>Item Name</label>
            <!-- {{itemModal}}unit -->
            <b-form-input :formatter="capitalizeAll" id="itemName" name="itemName" v-model="itemModal.itemName"
              disabled></b-form-input>
            <span class="error" v-if="!itemModal.itemName">{{ itemNameError }}</span>
          </b-col>

          <b-col md="2">
            <label>Required Quantity</label>
            <b-form-input :disabled="itemModal.itemUnitQ == 'pcs' ? true : false" :formatter="capitalizeAll"
              id="itemQuantity" name="itemQuantity" v-model="itemModal.itemQuantity" @keyup="finalAmount" type="number"
              min="0"></b-form-input>
            <span class="error" v-if="!itemModal.itemQuantity">{{
              itemQuantityError
              }}</span>
          </b-col>

          <b-col md="4">
            <label>Remark</label>
            <b-form-textarea :formatter="capitalizeAll" id="remark" name="remark"
              v-model="itemModal.remark"></b-form-textarea>
          </b-col>

          <b-col md="2">
            <b-button @click="addItem" style="margin-top: 16%" variant="primary" size="sm">
              {{ itemModal.itemForServiceEstId == "" ? "Add Item" : "Update Item" }}
            </b-button>
            <span class="error" v-if="!serviceDetails.itemForServiceEstId">{{
              additemError
              }}</span>
          </b-col>
        </b-row>

        <div style="background: beige" class="table-responsive mt-2"
          v-if="itemServiceDetails.length > 0 && userLevel != '1'">
          <h5 class="ml-2 py-2"><b>Requried Items Details :</b></h5>
          <table id="serviceEstimateItem" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>SN.</th>
                <!-- <th>Item Code</th> -->
                <th>Item Name</th>
                <th>Quantity Available</th>
                <th>Quantity Requested</th>
                <th>Creation Date</th>
                <th v-if="
                    serviceDetails.requestStatus == 'Rejected' ||
                    serviceDetails.requestStatus == ''
                  ">
                  Edit
                </th>
                <th v-if="
                    serviceDetails.requestStatus == 'Rejected' ||
                    serviceDetails.requestStatus == ''
                  ">
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in itemServiceDetails" :key="index">
                <td>{{ index + 1 }}</td>
                <!-- <td>{{item.itemCode}}</td> -->
                <td>{{ item.itemName }}</td>
                <td>
                  {{
                  parseInt(item.quantity) - parseInt(item.stockOut) <= 0 ? 0 : parseInt(item.quantity) -
                    parseInt(item.stockOut) }} </td>
                <td>{{ item.itemQuantity }}</td>

                <!-- table data for status column -->
                <!-- ( parseInt(item.quantity) - parseInt(item.stockOut) ) is quantity available -->
                <td v-if="item.stockOutFlag != 1">
                  <md-switch v-if="
                      parseInt(item.quantity) - parseInt(item.stockOut) > 0 &&
                      item.stockOutFlag != 1 &&
                      parseInt(item.itemQuantity) >
                        parseInt(item.quantity) - parseInt(item.stockOut) ==
                        false
                    " :id="'approval' + index" name="approval" class="md-primary" v-model="checked4[index].value"
                    @change="
                      fetchAndApprove(
                        item.itemId,
                        'yes',
                        item.itemQuantity,
                        index,
                        'no',
                        item.itemForServiceEstId
                      )
                    ">
                    {{ checked4[index].value == true ? "Approved" : "Not Approved" }}
                  </md-switch>

                  <span v-if="
                      parseInt(item.itemQuantity) >
                        parseInt(item.quantity) - parseInt(item.stockOut) ==
                        true && parseInt(item.quantity) - parseInt(item.stockOut) > 0
                    " class="warning">
                    <b>{{ "Requested Quantity is more than Available quantity!" }}</b>
                  </span>

                  <span v-if="parseInt(item.quantity) - parseInt(item.stockOut) <= 0" class="error">
                    <b>{{ "Requested Item Out of Stock !" }}</b>
                  </span>
                </td>

                <td v-if="item.stockOutFlag == 1">
                  <span class="success">
                    <b>
                      Service Estimation is already APPROVED & the requested quantity is
                      Stocked-Out</b>
                  </span>
                </td>

                <td>{{ item.loginTime | moment }}</td>
                <td v-if="
                    serviceDetails.requestStatus == 'Rejected' ||
                    serviceDetails.requestStatus == ''
                  ">
                  <md-button class="md-icon-button md-raised md-dense" @click="viewModalPage(item.itemForServiceEstId)"
                    :disabled="serviceDetails.approvedStatus == 'Sent For Approval'">
                    <md-icon>edit</md-icon>
                  </md-button>
                </td>

                <td v-if="
                    serviceDetails.requestStatus == 'Rejected' ||
                    serviceDetails.requestStatus == ''
                  ">
                  <md-button class="md-icon-button md-raised md-dense" @click="deleteData(item.itemForServiceEstId)"
                    :disabled="serviceDetails.approvedStatus == 'Sent For Approval'">
                    <md-icon>delete_sweep</md-icon>
                  </md-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style="background: beige" class="table-responsive mt-4"
          v-if="itemServiceDetails.length > 0 && userLevel == '1'">
          <h5 class="ml-2 py-2 pt-3"><b>Requried Items Details :</b></h5>
          <table id="serviceEstimateItem1" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>SN.</th>
                <!-- <th>Item Code</th> -->
                <th>Item Name</th>
                <th>Quantity Available</th>
                <th>Quantity Requested</th>
                <th>Status</th>
                <th>Creation Date</th>
                <th>Edit</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in itemServiceDetails" :key="index">
                <!-- {{
                  item
                }} -->
                <td>{{ index + 1 }}</td>
                <!-- <td>{{item.itemCode}}</td> -->
                <td>
                  {{ item.itemName }}
                  <br />
                  <b-button v-if="
                      item.itemUnit == 'pcs' &&
                      item.itemId &&
                      !(
                        parseInt(item.itemQuantity) >
                          parseInt(item.quantity) - parseInt(item.stockOut) ==
                          true && parseInt(item.quantity) - parseInt(item.stockOut) > 0
                      ) &&
                      !(parseInt(item.quantity) - parseInt(item.stockOut) <= 0)
                    " variant="primary" size="sm" class="py-2" @click="openUpdateSubItemModal(item)"
                    id="addButtonLoader">
                    {{ item.itemId ? "Sub Item's" : "Sub Item's" }}
                  </b-button>
                  <!-- {{item.itemUnit}} -->
                </td>
                <td>
                  {{
                  parseInt(item.quantity) - parseInt(item.stockOut) <= 0 ? 0 : parseInt(item.quantity) -
                    parseInt(item.stockOut) }} </td>
                <td>{{ item.itemQuantity }}<span
                    v-if="item.itemQuantityUnitMinus">/{{item.itemQuantityUnitMinus}}</span></td>

                <!-- table data for status column -->
                <!-- ( parseInt(item.quantity) - parseInt(item.stockOut) ) is quantity available -->
                <td v-if="item.stockOutFlag != 1">
                  <md-switch v-if="
                      parseInt(item.quantity) - parseInt(item.stockOut) > 0 &&
                      item.stockOutFlag != 1 &&
                      parseInt(item.itemQuantity) >
                        parseInt(item.quantity) - parseInt(item.stockOut) ==
                        false
                    " :id="'approval' + index" name="approval" class="md-primary" v-model="checked4[index].value"
                    @change="
                      fetchAndApprove(
                        item.itemId,
                        'yes',
                        item.itemQuantity,
                        index,
                        'no',
                        item.itemForServiceEstId
                      )
                    ">
                    {{ checked4[index].value == true ? "Approved" : "Not Approved" }}
                  </md-switch>

                  <span v-if="
                      parseInt(item.itemQuantity) >
                        parseInt(item.quantity) - parseInt(item.stockOut) ==
                        true && parseInt(item.quantity) - parseInt(item.stockOut) > 0
                    " class="warning">
                    <b>{{ "Requested Quantity is more than Available quantity!" }}</b>
                  </span>

                  <span v-if="parseInt(item.quantity) - parseInt(item.stockOut) <= 0" class="error">
                    <b>{{ "Requested Item Out of Stock !" }}</b>
                  </span>
                </td>

                <td v-if="item.stockOutFlag == 1">
                  <span class="success">
                    <b>
                      Service Estimation is already APPROVED & the requested quantity is
                      Stocked-Out</b>
                  </span>
                </td>
                <!-- table data for status column end-->

                <td>{{ item.loginTime | moment }}</td>
                <td>
                  <md-button v-if="item.stockOutFlag != 1" class="md-icon-button md-raised md-dense"
                    @click="viewModalPage(item.itemForServiceEstId)">
                    <md-icon>edit</md-icon>
                  </md-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Subitem List Modal Start -->
        <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="Sub-Item-Modal" hide-footer
          :title="'Sub Item List'">
          <b-table show-empty stacked="md" :items="PS_subItemList" :fields="PS_subItemFields">
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 }}</span>
            </template>
            <template slot="is_quanity" slot-scope="row1">
              <div :id="'row' + row1.item.lead_id">
                <md-switch :id="'approval' + row1.item.lead_id" name="approval" class="md-primary"
                  :value="row1.item.is_quanity == 1 ? true : false" @change="isQuanityMinus(row1.item)" :disabled="
                  
                    (row1.item.is_quanity == 1 && row1.item.se_sub_item_id)
                      ? true
                      : false
                  ">
                  <!-- ($sessionsStorage.get('designation') != 'Admin' && -->
                  <!-- $sessionsStorage.get('nameUser') != 'Bhavneesh') || -->
                  <h6>
                    <br />
                    <b-badge :variant="row1.item.is_quanity == 1 ? 'success' : 'danger'">{{ row1.item.is_quanity == 1 ?
                      "Done" : "Pending" }}</b-badge>
                  </h6>
                </md-switch>
              </div>
            </template>
          </b-table>
          <b-row>
            <b-col md="12"> </b-col>
            <b-col cols="12" class="text-center">
              <b-button class="mt-3" variant="outline-danger" size="xs" style="font-size: 0.675rem"
                @click="hideSubItemModal">Close</b-button>
            </b-col>
          </b-row>
        </b-modal>
        <!-- Subitem List Modal End -->

        <!-- Main approval confirmation pop-up modal -->
        <b-modal no-close-on-esc no-close-on-backdrop size="lg" ref="confirm_modal_main"
          title="Confirm Service Estimation Approval !" centered hide-footer>
          <div style="font-size: 16px; text-align: center">
            <span class="warning">
              <b>
                Once Estimation is Approved, the requested quantity gets stocked out
              </b>
            </span>
            <br />
            <span class="error">
              <b> Note: User cannot undo Estimation Approval once Confirmed</b>
            </span>
          </div>

          <div style="margin-top: 2%; text-align: center">
            <b-button variant="danger" @click="cancleApproval()"> Reject </b-button>

            <b-button variant="success" @click="
                fetchAndApprove(
                  selecteditemId,
                  'yes',
                  reqQuantity,
                  quantityIndex,
                  'yes',
                  itemForServiceEstId
                );
                confirmApproval();
              ">
              Confirm Approval</b-button>
          </div>
        </b-modal>

        <!-- confirmation pop-up modal -->
        <b-modal no-close-on-esc no-close-on-backdrop size="m" ref="confirm_modal"
          title="Confirm the check-out of Selected Item !" centered hide-footer>
          <div style="margin-left: 28%">
            <b-button variant="danger" @click="cancelConfirmation()"> Cancel </b-button>

            <b-button variant="success" @click="confirmed()"> Confirm </b-button>
          </div>
        </b-modal>

        <!-- Sub Item Listing table Modal -->
        <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="Item-modal" title="Available Sub Item List"
          centered>
          <b-col md="12">
            <b-button class="mb-2" variant="primary" @click="
                fetchAndApprove(
                  selecteditemId,
                  '',
                  reqQuantity,
                  quantityIndex,
                  'no',
                  itemForServiceEstId
                )
              ">
              All Items
            </b-button>

            <b-button class="mb-2" variant="primary" @click="
                fetchAndApprove(
                  selecteditemId,
                  'yes',
                  reqQuantity,
                  quantityIndex,
                  'no',
                  itemForServiceEstId
                )
              ">
              Show Only Stocked-In items
            </b-button>

            <b-form-group>
              <b-input-group>
                <b-form-input :formatter="capitalizeAll" v-model="subItemfilter"
                  placeholder="Type to Search sub Item" />
                <b-input-group-append>
                  <b-button :disabled="!subItemfilter" @click="subItemfilter = ''">Clear</b-button>
                </b-input-group-append>
                <h5 class="text-muted pull-right mt-2 ml-3">
                  <small v-if="isLoading == false">{{ totalRowsSubItem }} Sub Items</small>
                </h5>
              </b-input-group>
            </b-form-group>
          </b-col>

          <div class="table-responsive tableMain">
            <b-table show-empty stacked="md" :items="subItemList" :fields="subItemfields" :current-page="currentPage"
              :per-page="perPageSubItem" :filter="subItemfilter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection" @filtered="onSubItemFiltered">
              <template slot="itemId" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPageSubItem }}</span>
              </template>

              <template slot="subItemName" slot-scope="row1">
                <span>{{ row1.item.sub_item_name }}</span>
              </template>

              <template slot="serialNo" slot-scope="row2">
                <span>{{ row2.item.sub_item_code }}</span>
              </template>

              <template slot="installationDate" slot-scope="row3">
                <span>{{ row3.item.installation_date }}</span>
              </template>

              <template slot="manufacturingDate" slot-scope="row4">
                <span>{{ row4.item.manufacture_date }}</span>
              </template>

              <template slot="expiryDate" slot-scope="row5">
                <span>{{ row5.item.expiry_date }}</span>
              </template>

              <template slot="stockReceivedDate" slot-scope="row6">
                <span>{{ row6.item.sub_item_received_date }}</span>
              </template>

              <template slot="stockReceivedBy" slot-scope="row7">
                <span>{{ row7.item.receivedBy }}</span>
              </template>

              <template slot="stockoutdate" slot-scope="row8">
                <span>{{ row8.item.sub_item_stockout_date }}</span>
              </template>

              <template slot="checkOut" slot-scope="row9">
                <b-form-checkbox v-if="row9.item.isChecked_Out == 'no'" v-model="row9.item.isChecked_Out"
                  :disabled="isCheckboxDisabled(row9.item)" @change="showConfirmationModal(row9.item)" />
                <!-- @change="checkOut(row9.item.po_sub_item_id, row9.item, row9.item.isChecked_Out )"  -->

                <span v-else class="error">{{ row9.item.isChecked_Out }}</span>
              </template>
            </b-table>
          </div>

          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination limit="25" :total-rows="totalRowsSubItem" :per-page="perPageSubItem" v-model="currentPage"
                class="my-0 pull-right" />
            </b-col>
          </b-row>
        </b-modal>

        <!-- Vehicle History table Modal -->
        <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="vehicle-modal" title="Vehicle History List"
          centered>
          <b-col md="12" v-if="!showRequiredItemsList">
            <b-form-group>
              <b-input-group>
                <b-form-input :formatter="capitalizeAll" v-model="vehicleHistoryfilter"
                  placeholder="Search Vehicle No. / Series / Approval / Complain" />
                <b-input-group-append>
                  <b-button :disabled="!vehicleHistoryfilter" @click="vehicleHistoryfilter = ''">Clear</b-button>
                </b-input-group-append>
                <h5 class="text-muted pull-right mt-2 ml-3">
                  <small v-if="isLoading == false">{{ totalRowsVehicleHistory }} History Entries</small>
                </h5>
              </b-input-group>
            </b-form-group>
          </b-col>

          <div class="table-responsive tableMain">
            <!-- vehicle history table -->
            <b-table v-if="!showRequiredItemsList" show-empty stacked="md" :items="vehicleHistoryList"
              :fields="vehicleHistoryFields" :current-page="currentPage" :per-page="perPageVehicleHistory"
              :filter="vehicleHistoryfilter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection" @filtered="onvehicleHistoryFiltered">
              <template slot="vehicleId" slot-scope="row0">
                <span>{{
                  row0.index + 1 + (currentPage - 1) * perPageVehicleHistory
                  }}</span>
              </template>

              <template slot="vehicleNo" slot-scope="row1">
                <span>{{ row1.item.vehicleNo }}</span>
              </template>

              <template slot="serviceEstSeries" slot-scope="row2">
                <span @click="viewRequiredItemList(row2.item.itemForServiceEstId)" class="showMoreData">
                  {{ row2.item.serviceEstSeries }}
                </span>
              </template>

              <template slot="driverName" slot-scope="row3">
                <span>{{ row3.item.driverName }}</span>
              </template>

              <template slot="estimationDate" slot-scope="row4">
                <span>{{ row4.item.serviceEstDate }}</span>
              </template>

              <template slot="odometreReading" slot-scope="row5">
                <span>{{ row5.item.odometre_Reading }}
                  <small v-if="row5.item.odometre_Reading != null"> km</small>
                </span>
              </template>

              <template slot="driverComplain" slot-scope="row6">
                <span>{{ row6.item.driver_complain }}</span>
              </template>

              <template slot="approvedStatus" slot-scope="row7">
                <span v-if="row7.item.approvedStatus == 'Approved'" class="success">{{
                  row7.item.approvedStatus
                  }}</span>
                <span v-else class="error">{{ row7.item.approvedStatus }}</span>
              </template>

              <template slot="approvedBy" slot-scope="row8">
                <span>{{ row8.item.approvedBy }}</span>
              </template>
            </b-table>

            <!-- navigation button for two tables -->
            <b-button v-if="showRequiredItemsList" class="mb-2 mt-2 ml-2" variant="primary"
              @click="gobackToVehicleHistory()">
              Go back to Vehicle History
            </b-button>

            <large v-if="showRequiredItemsList" class="pull-right mt-3 mr-2">
              Vehicle No.: <b class="warning">{{ serviceDetails.vehicleNo }}</b>
            </large>

            <!-- Aproval history on click of SE series -->
            <b-table v-if="showRequiredItemsList" show-empty stacked="md" :items="itemServiceDetails"
              :fields="itemServiceDetailsFields" :current-page="currentPage" :per-page="perPageItemServiceDetails"
              :filter="itemServiceDetailsfilter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection">
              <template slot="itemId" slot-scope="row0">
                <span>{{
                  row0.index + 1 + (currentPage - 1) * perPageItemServiceDetails
                  }}</span>
              </template>

              <template slot="itemName" slot-scope="row1">
                <span>{{ row1.item.itemName }}</span>
              </template>

              <template slot="quantity" slot-scope="row3">
                <span>{{ row3.item.quantity }}</span>
              </template>

              <template slot="itemQuantity" slot-scope="row4">
                <span>{{ row4.item.itemQuantity }}</span>
              </template>

              <template slot="loginTime" slot-scope="row6">
                <span>{{ row6.item.loginTime }}</span>
              </template>

              <template slot="approvedStatus" slot-scope="row7">
                <span v-if="row7.item.approvedStatus == 'Approved'" class="success">{{
                  row7.item.approvedStatus
                  }}</span>
                <span v-else class="error">{{ row7.item.approvedStatus }}</span>
              </template>

              <template slot="approvedBy" slot-scope="row8">
                <span>{{ row8.item.approvedBy }}</span>
              </template>
            </b-table>
          </div>

          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination v-if="!showRequiredItemsList" limit="25" :total-rows="totalRowsVehicleHistory"
                :per-page="perPageVehicleHistory" v-model="currentPage" class="my-0 pull-right" />
            </b-col>
          </b-row>
        </b-modal>
        <!-- {{ disableBTN + "PS" }} -->
        <b-row v-if="userLevel == '1' && this.serviceDetails.serviceEstimationId != ''">
          <b-col md="4">
            <label>Manager Name</label>
            <b-form-input :formatter="capitalizeAll" id="approvedBy" name="approvedBy"
              v-model="serviceDetails.approvedBy" disabled></b-form-input>
          </b-col>

          <b-col md="3">
            <label for="maintenanceType">Update Estimation Request</label>
            <model-list-select :list="UStatusList" v-model="serviceDetails.requestStatus" option-value="USVal"
              option-text="USText" placeholder="Select "></model-list-select>
            <span class="error" v-if="
                serviceDetails.requestStatus == 'Sent For Approval' && userLevel == '1'
              ">{{ requestStatusError }}</span>
          </b-col>
        </b-row>

        <hr class="hr-s" />

        <b-row v-if="
            jobTypeMaster.length == 0 &&
            serviceDetails.onRejectStatus != '3' &&
            itemServiceDetails.length > 0
          ">
          <b-col>
            <md-button :disabled="disableBTN" class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
              @click="addServiceEst('Pending')" id="addButtonLoader" v-if="
                (serviceDetails.approvedStatus == 'Pending' ||
                  serviceDetails.approvedStatus == 'Rejected' ||
                  serviceDetails.approvedStatus == '' ||
                  (userLevel == '1' &&
                    (serviceDetails.approvedStatus == 'Sent For Approval' ||
                      serviceDetails.approvedStatus == 'On_Hold'))) &&
                !disableBTN
              ">
              Save
              <!-- {{ disableBTN + "PS" }} -->
            </md-button>
          </b-col>

          <b-col>
            <md-button class="md-raised md-primary md-button-color heght-1px mrgtop-2per" id="addButtonLoader1"
              @click="addServiceEst('Sent For Approval')" v-if="
                userLevel != '1' &&
                (serviceDetails.approvedStatus == 'Pending' ||
                  serviceDetails.approvedStatus == 'Rejected' ||
                  serviceDetails.approvedStatus == '')
              ">
              Send For Approval
            </md-button>
            <md-spinner md-indeterminate id="loader1" style="display: none"></md-spinner>
          </b-col>
        </b-row>

        <b-row v-if="jobTypeMaster.length <= 0 && serviceDetails.approvedStatus == 'Approved'">
          <b-col>
            <md-button class="md-raised md-primary md-button-color heght-1px mrgtop-2per" @click="jobType"
              id="addButtonLoader2">
              Create Job Order
            </md-button>
            <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
          </b-col>
        </b-row>

        <md-layout v-if="notValid != true && userLevel == '1'">
          <h3 class="error">{{ errorNotApproved }}</h3>
        </md-layout>

        <md-layout v-if="serviceDetails.onRejectStatus == '3'">
          <h3 class="error">This Job Order is Rejected 3 times..!</h3>
        </md-layout>
      </md-card-content>
    </md-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop4"
      @close="onClose3"></md-dialog-alert>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop3"
      @close="onClose3"></md-dialog-alert>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop" @close="onClose"></md-dialog-alert>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop1"
      @close="onClose1"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose6"
      ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import Vue from "vue";
import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import MaintenanceService from "../../../services/MaintenanceService.js";

export default {
  beforeMount() {
    if (globalPermissionStatus("Maintanence")) {
      this.$store.dispatch("setCurrentRoute", "/serviceEstimation/serviceEstimation");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      PS_save_subItemList: [],
      PS_subItemList: [],
      PS_subItemFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "itemName",
          mainkey: "itemName",
          label: "Item Name",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "sub_item_name",
          mainkey: "sub_item_name",
          label: "Sub Item Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "sub_item_code",
          mainkey: "sub_item_code",
          label: "Sub Item Code",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "is_quanity",
          mainkey: "is_quanity",
          label: "Quantity",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "createdBy",
          mainkey: "createdBy",
          label: "Created By",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "created_at",
          mainkey: "created_at",
          label: "Created Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "updatedBy",
          mainkey: "updatedBy",
          label: "Updated By",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "updated_at",
          mainkey: "updated_at",
          label: "Updated Date",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
      ],
      vehicleHistoryList: [],
      vehicleID: "",
      vehicleHistoryfilter: null,
      perPageVehicleHistory: 5,
      totalRowsVehicleHistory: "",

      vehicleHistoryFields: [
        {
          key: "vehicleId",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vehicleNo",
          label: "Vehicle No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "serviceEstSeries",
          label: "SE Series",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "driverName",
          label: "Driver Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "estimationDate",
          label: "Estimation Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "odometreReading",
          label: "Meter Reading on Estimation",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "driverComplain",
          label: "Driver Complain",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "approvedStatus",
          label: "Approved Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "approvedBy",
          label: "Approved By",
          sortable: true,
          sortDirection: "desc",
        },
      ],

      showRequiredItemsList: false,
      itemServiceDetailsfilter: null,
      perPageItemServiceDetails: 8,

      itemServiceDetailsFields: [
        {
          key: "itemId",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "itemName",
          label: "Item Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "quantity",
          label: "Available Quantity",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "itemQuantity",
          label: "Item Quantity",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "loginTime",
          label: "Creation Time",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "approvedStatus",
          label: "Approved Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "approvedBy",
          label: "Approved By",
          sortable: true,
          sortDirection: "desc",
        },
      ],

      subItemList: [],
      selecteditemId: "",
      totalRowsSubItem: "",
      perPageSubItem: 5,
      subItemfilter: null,
      showConfirmation: false,
      selectedItem: null,
      selectedCheckbox: null,

      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      currentPage: 1,
      quantityIndex: "",
      itemForServiceEstId: "",
      checkedValue: "",
      checkedItems: [],

      subItemfields: [
        {
          key: "itemId",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "subItemName",
          label: "Sub Item Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "serialNo",
          label: "Serial No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "installationDate",
          label: "Installation Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "manufacturingDate",
          label: "Manufacturing Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "expiryDate",
          label: "Expiry Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "stockReceivedDate",
          label: "Stock Received Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "stockReceivedBy",
          label: "Stock Received By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "stockoutdate",
          label: "Stock Out Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "checkOut",
          label: "CheckOut",
          sortable: true,
          sortDirection: "desc",
        },
      ],

      selectDateFormat,
      UStatusList: [
        {
          USVal: "Approved",
          USText: "Approve",
        },
        {
          USVal: "On_Hold",
          USText: "On Hold",
        },
        {
          USVal: "Rejected",
          USText: "Reject",
        },
      ],
      MaintainList: [
        {
          MVal: "Vehicle",
          MText: "Vehicle",
        },
        {
          MVal: "Yard",
          MText: "Yard",
        },
        {
          MVal: "Office",
          MText: "Office",
        },
      ],
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      alert: {
        content:
          this.$sessionsStorage.get("editServiceId") != "" &&
          this.$sessionsStorage.get("editServiceId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },

      jobNatureList: [
        {
          natureVal: "minorWork",
          natureText: "Minor Work",
        },
        {
          natureVal: "service",
          natureText: "Service",
        },
        {
          natureVal: "accidentalJob",
          natureText: "Accidental Job",
        },
      ],

      checked4: [],
      openSubItemModal: false,
      isLoading: "",
      serviceDetails: {
        serviceEstSeries: "",
        serviceEstimationDate: "",
        serviceEstimationId: "",
        maintenanceType: "",
        vehicleNo: "",
        vehicleYard: "",
        vehicleId: "",
        engineNo: "",
        chassisNo: "",
        yearOfPurchase: "",
        driverName: "",
        requestedBy: "",
        containerType: "",
        containerNo: "",
        department: "",
        itemForServiceEstId: "",
        approvedStatus: "",
        requestStatus: "",
        approvedBy: "",
        approvedById: "",
        addQuantityStatus: "",
        onRejectStatus: "",
        availableQuantity: "",
        driver_complain: "",
        odometre_Reading: "",
        job_nature: "",
      },
      jobTypeMaster: [],
      serviceEstimationDateError: "",
      checkStatusApproval: "",
      itemModal: {
        itemForServiceEstId: "",
        serviceEstimationId: "",
        itemCode: "",
        itemName: "",
        itemNameCode: "",
        ratePerUnit: "",
        itemQuantity: "",
        totalAmount: "",
        quantityitem: "",
        itemId: "",
        approval: "",
        remark: "",
        itemUnitQ: "",
      },
      total: "",

      itemMasterService: [],

      validate: true,
      stockInDateError: "",

      addedByPersonError: "",

      poDateError: "",
      vendorNamError: "",
      goodsStatusError: "",
      qualityCheckError: "",
      maintenanceTypeError: "",
      odometreReadingError: "",
      job_natureError: "",
      itemNameError: "",
      ratePerUnitError: "",
      itemQuantityError: "",
      additemError: "",
      requestStatusError: "",

      stockReceivedDateError: "",
      employeeMaster: [
        {
          employeeName: "ajit",
        },
      ],
      locationMaster: [
        {
          pickupLocation: "mumbai",
        },
      ],
      containerMaster: [
        {
          pickupLocation: "mumbai",
        },
      ],
      vendorMaster: [],
      departmentMaster: [],
      itemCodeError: "",
      itemDetail: [{}],
      approvedStatus: [{}],
      VehicleAuto: {},
      itemAuto: {},
      vehicleDetail: [{}],
      locationDetail: [{}],
      containerDetail: [{}],

      dapartmentDetail: [],
      vendorDetail: [],
      itemServiceDetails: [],
      designation: this.$sessionsStorage.get("designation"),
      userLevel: this.$sessionsStorage.get("userLevel"),
      notValid: true,
      errorItem: "",
      errorNotApproved: "",

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editServiceId") != "" &&
          this.$sessionsStorage.get("editServiceId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editServiceId") != "" &&
          this.$sessionsStorage.get("editServiceId") != undefined
            ? "Update"
            : "New",
      },

      disableBTN: false,
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },
  watch: {
    VehicleAuto: {
      handler: function (newVal, oldVal) {
        this.requestVehicleCallback(newVal);
      },
      deep: true,
    },
    itemAuto: {
      handler: function (newVal, oldVal) {
        this.findItemCode(newVal);
      },
      deep: true,
    },
  },

  computed: {
    checkStatus() {
      return (this.checkStatusApproval =
        this.serviceDetails.approvedStatus == "Approved");
    },
    itemMasterList() {
      return this.itemDetail.map((item) => {
        item.displayList = `${item.itemName} - ${item.part_number}`;
        return item;
      });
    },
    vehicleMasterList() {
      return this.vehicleDetail;
    },
    locationMasterList() {
      return this.locationMaster;
    },
    containerMasterList() {
      return this.containerMaster;
    },
    employeeMasterList() {
      return this.employeeMaster;
    },
  },
  methods: {
    isQuanityMinus(item) {
      const index = this.PS_save_subItemList.findIndex(
        (item_det) => item_det.po_sub_item_id === item.po_sub_item_id
      );
      if (index !== -1) {
        this.PS_save_subItemList.splice(index, 1);
      } else {
        item.is_quanity=1;
        this.PS_save_subItemList.push(item);
      }
      console.log("this.PS_save_subItemList=>", this.PS_save_subItemList);
    },
    openUpdateSubItemModal(item) {
      this.PS_subItemList = [];
      console.log("Item=>", item);
      let payload = {
        item_id: item.itemId,
        item_name: item.itemName,
        itemCode: "getSubItemList",
      };
      MaintenanceService.getAllMaintenanceList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data.subItemList.length > 0) {
            this.PS_subItemList = data.subItemList;
            this.$refs["Sub-Item-Modal"].show();
          }
          console.log("subItemList=>", this.PS_subItemList);
        })
        .catch((error) => {
          console.log("Catch on getSubItemList Error: ", error);
        });
    },
    hideSubItemModal() {
      this.PS_subItemList = [];
      this.$refs["Sub-Item-Modal"].hide();
    },

    onvehicleHistoryFiltered(filteredItems) {
      this.totalRowsVehicleHistory = filteredItems.length;
      this.currentPage = 1;
    },

    showVehicleHistory(vehicleID, type) {
      console.log("vehicle Hist ID", vehicleID);
      this.$refs["vehicle-modal"].show();
      this.isLoading = true;

      let payload = {
        view: "vehicleHistory",
        vehicleID: vehicleID,
        type: type,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewItemDetail.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.vehicleHistoryArray.length > 0) {
              this.vehicleHistoryList = data.vehicleHistoryArray;
              this.totalRowsVehicleHistory = data.vehicleHistoryArray.length;
            } else {
              this.vehicleHistoryList = [];
              this.totalRowsVehicleHistory = "";
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    showConfirmationModal(item) {
      this.selectedItem = item;
      this.showConfirmation = true;
      this.$refs["confirm_modal"].show();
    },

    confirmed() {
      this.checkOut(
        this.selectedItem.po_sub_item_id,
        this.selectedItem,
        this.selectedItem.isChecked_Out
      );
      this.showConfirmation = false;
      this.$refs["confirm_modal"].hide();
    },

    confirmApproval() {
      this.$refs["confirm_modal_main"].hide();
      this.$refs["Item-modal"].show();
      this.checked4[this.quantityIndex].value = true;
      this.openSubItemModal = true;
    },

    cancleApproval() {
      this.$refs["confirm_modal_main"].hide();
      this.checked4[this.quantityIndex].value = false;
      this.openSubItemModal = false;
    },

    cancelConfirmation() {
      const item = this.selectedItem;
      this.showConfirmation = false;
      if (item) {
        this.fetchAndApprove(
          this.selecteditemId,
          "yes",
          this.reqQuantity,
          this.quantityIndex,
          "no",
          this.itemForServiceEstId
        );
      }
      this.$refs["confirm_modal"].hide();
    },

    isCheckboxDisabled(item) {
      return this.selectedCheckbox && this.selectedCheckbox !== item;
    },

    checkOut(subItemID, item, isChecked) {
      console.log("Checkbox changed for item id:", subItemID);
      console.log("Req Qty:", this.reqQuantity);
      this.isLoading = true;

      if (this.selectedCheckbox !== item) {
        this.selectedCheckbox = item;
        this.subItemList.forEach((subItem) => {
          if (subItem !== item) {
            subItem.isChecked_Out = "no";
          }
        });
      } else {
        item.isChecked_Out = "no";
        this.selectedCheckbox = null;
      }

      item.isChecked_Out = isChecked ? "yes" : "no";
      console.log("Checkbox value:", item.isChecked_Out);

      let payload = {
        view: "checkOut",
        subItemID: subItemID,
        isChecked_Out: item.isChecked_Out,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewItemDetail.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    onSubItemFiltered(filteredItems) {
      this.totalRowsSubItem = filteredItems.length;
      this.currentPage = 1;
    },

    fetchAndApprove(
      itemID,
      stockOut,
      reqQuantityParam,
      index,
      checkedValue,
      itemForServiceEstId
    ) {
      console.log("salil", checkedValue);
      this.selecteditemId = itemID;
      this.reqQuantity = reqQuantityParam;
      this.quantityIndex = index;
      this.itemForServiceEstId = itemForServiceEstId;

      this.isLoading = true;

      if (!this.checked4[index].value) {
        this.$refs["confirm_modal_main"].show();
      }

      let payload = {
        view: "Quantity_details",
        itemID: itemID,
        stockOut: stockOut,
        quantity: reqQuantityParam,
        checkedValue: checkedValue,
        itemForServiceEstId: itemForServiceEstId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewItemDetail.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.subItemsArray.length > 0) {
              this.subItemList = data.subItemsArray;
              this.totalRowsSubItem = data.subItemsArray.length;
            } else {
              this.subItemList = [];
              this.totalRowsSubItem = "";
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    removeCss() {
      $(".md-active").remove();
    },

    emptyOdometerReading() {
      this.serviceDetails.odometre_Reading = "";
    },

    emptyVehicleDetails() {
      this.VehicleAuto = {};
      this.serviceDetails.engineNo = "";
      this.serviceDetails.vehicleNo = "";
      this.serviceDetails.driverName = "";
      this.serviceDetails.chassisNo = "";
      this.serviceDetails.odometre_Reading = "";
      this.serviceDetails.driver_complain = "";
      this.serviceDetails.yearOfPurchase = "";
      this.serviceDetails.job_nature = "";
    },

    hideVehicle() {
      if (this.serviceDetails.maintenanceType == "Yard") {
        this.serviceDetails.engineNo = "";
        this.serviceDetails.vehicleNo = "";
        this.serviceDetails.vehicleId = "";
        this.serviceDetails.driverName = "";
        this.serviceDetails.chassisNo = "";
        this.serviceDetails.yearOfPurchase = "";
      } else if (this.serviceDetails.maintenanceType == "Office") {
        this.serviceDetails.vehicleYard = "";
        this.serviceDetails.engineNo = "";
        this.serviceDetails.vehicleNo = "";
        this.serviceDetails.driverName = "";
        this.serviceDetails.chassisNo = "";
        this.serviceDetails.yearOfPurchase = "";
        this.serviceDetails.vehicleId = "";
      } else if (this.serviceDetails.maintenanceType == "Vehicle") {
        this.serviceDetails.engineNo = "";
        this.serviceDetails.vehicleYard = "";
        this.serviceDetails.vehicleNo = "";
        this.serviceDetails.driverName = "";
        this.serviceDetails.chassisNo = "";
        this.serviceDetails.yearOfPurchase = "";
        this.serviceDetails.vehicleId = "";
      }
    },

    deleteData(ServiceEstitemID) {
      this.itemForServiceEstId = ServiceEstitemID;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },

    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "main_itemforserviceest",
          tableId: "itemForServiceEstId",
          tableVal: this.itemForServiceEstId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (data.clientId != "" && status == 200 && data) {
              this.viewEditServiceEstimation();
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },

    viewModalPage(itemID) {
      let array = this.itemServiceDetails.filter((x) => {
        return x.itemForServiceEstId == itemID;
      });

      Object.keys(this.itemModal).map((x) => {
        this.itemModal[x] = array[0][x] || "";
      });

      // this.itemModal.itemNameCode = array[0].itemName + "-" + array[0].itemCode;
    },
    onClose3(type) {
      this.$router.push({
        path: "/serviceEstimation/viewServiceEstimation",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#serviceEstimateItem").DataTable();
        return $("#serviceEstimateItem1").DataTable();
      });
    },
    findItemCode(item) {
      this.itemModal.itemQuantity = "";
      this.itemModal.ratePerUnit = item.ratePerUnit;
      this.itemModal.itemName = item.itemName;
      this.itemModal.itemCode = item.itemCode;
      this.itemModal.itemId = item.itemId;
      this.itemModal.itemNameCode = item.itemNameCode;
      this.itemModal.remark = item.remark;
      this.itemModal.itemUnitQ = item.unit;
      if (item.unit == "pcs") {
        this.itemModal.itemQuantity = item.quantity;
      }
    },

    requestVehicleCallback(item1) {
      this.serviceDetails.engineNo = item1.engineNo;
      this.serviceDetails.vehicleNo = item1.regdNo;
      this.serviceDetails.chassisNo = item1.chassisNo;
      this.serviceDetails.driverName = item1.driverName;
      this.serviceDetails.vehicleId = item1.vehicleTruckId;
      this.serviceDetails.yearOfPurchase = item1.vmodelYear;
      this.vehicleID = item1.vehicleTruckId;
    },
    requestContainerCallback(item1) {
      this.serviceDetails.containerType = item1.containerType;
    },
    jobType() {
      this.$router.push({
        path: "/jobOrderSheet/jobOrderSheet",
      });
    },

    getData() {
      this.isLoading = true;
      let vehicle_drive = {
        itemCode: "itemCode",
        serviceEstimationId: this.$sessionsStorage.get("editServiceId"),
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/fetchToStockIn.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.itemMaster.length > 0) {
              this.itemMasterService = data.itemMaster;
            }

            if (data.jobTypeMaster.length > 0) {
              this.jobTypeMaster = data.jobTypeMaster;
            } else {
              this.jobTypeMaster = [];
            }
            if (data.vehicleDetail.length > 0) {
              this.vehicleDetail = data.vehicleDetail;
              console.log("Vehicles count", data.vehicleDetail.length);
            }

            if (data.itemDetail.length > 0) {
              this.itemDetail = data.itemDetail;
            } else {
              this.itemDetail = ["dfgdf"];
            }
            if (data.vehicleDetail.length > 0) {
              this.departmentMaster = data.departmentMaster;
            }
            if (data.vehicleDetail.length > 0) {
              this.containerDetail = data.containerMaster;
            }
            if (data.UserDetail.length > 0) {
              this.serviceDetails.requestedBy = data.UserDetail[0].employeeName;
            }
            if (
              this.$sessionsStorage.get("editServiceId") != "" &&
              this.$sessionsStorage.get("editServiceId") != undefined
            ) {
              this.viewEditServiceEstimation();
            } else {
              if (data.UserDetail.length > 0) {
                this.serviceDetails.requestedBy = data.UserDetail[0].employeeName;
              }
            }
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    onClose(type) {
      this.$router.push({
        path: "/serviceEstimation/viewServiceEstimation",
      });
    },
    approvalRequest() {
      let client_detail = {
        approvedBy: "approvedBy",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/serviceApprovalRequest.php`,
        data: JSON.stringify(client_detail),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
        })
        .catch((error) => {});
    },

    validateJobOrder() {
      let validate_new = true;

      if (this.serviceDetails.maintenanceType == "") {
        $("#maintenanceType").focus();
        this.maintenanceTypeError = "Select Maintenance Type";
        validate_new = false;
      }

      if (this.serviceDetails.maintenanceType == "Vehicle") {
        if (this.serviceDetails.odometre_Reading == "") {
          $("#odometre_Reading").focus();
          this.odometreReadingError = "Enter Odometer Reading";
          validate_new = false;
        }

        if (this.serviceDetails.job_nature == "") {
          $("#job_nature").focus();
          this.job_natureError = "Job Nature Required";
          validate_new = false;
        }
      }

      if (this.serviceDetails.serviceEstimationDate == "") {
        $("#serviceEstimationDate").focus();
        this.serviceEstimationDateError = "Select Date";
        validate_new = false;
      }
      if (this.serviceDetails.itemForServiceEstId == "") {
        this.additemError = "Add minimum one Item..! ";
        validate_new = false;
      }

      if (
        this.serviceDetails.requestStatus == "Sent For Approval" &&
        this.userLevel == "1"
      ) {
        validate_new = false;
        this.requestStatusError = "Select Estimation Request";
      }

      if (
        this.notValid != true &&
        this.userLevel == "1" &&
        this.serviceDetails.requestStatus == "Approved"
      ) {
        validate_new = false;
        this.errorNotApproved =
          " Requried " + this.errorItem + " Quantity is greater than Available Quantity";
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    validateModal() {
      let validate_new = true;

      if (this.itemModal.itemName == "") {
        $("#itemName").focus();
        this.itemNameError = "Enter Item Name";
        validate_new = false;
      }
      if (this.itemModal.itemCode == "" && this.itemModal.itemForServiceEstId == "") {
        $("#itemCode").focus();
        this.itemCodeError = "Enter Item Code";
        validate_new = false;
      }
      if (this.itemModal.itemQuantity == "") {
        $("#itemQuantity").focus();
        this.itemQuantityError = "Enter Quantity ";
        validate_new = false;
      }
      // if (this.itemModal.ratePerUnit == "") {
      //   $("#ratePerUnit").focus();
      //   this.ratePerUnitError = "Enter  Rate per unit";
      //   validate_new = false;
      // }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    checkButtonDisable() {
      this.disableBTN = false;

      if (this.itemServiceDetails.length > 0) {
        for (let j = 0; j < this.itemServiceDetails.length; j++) {
          //  if (
          //             this.itemModal.itemQuantity == this.itemServiceDetails[j].itemQuantity &&
          //             this.itemServiceDetails[j].itemId == this.itemModal.itemId
          //           ) {
          //           }
          if (
            parseInt(this.itemServiceDetails[j].itemQuantity) >
            parseInt(this.itemServiceDetails[j].quantity) -
              parseInt(this.itemServiceDetails[j].stockOut)
          ) {
            // alert(parseInt(this.itemServiceDetails[j].itemQuantity));
            // alert(
            //   parseInt(this.itemServiceDetails[j].quantity) -
            //     parseInt(this.itemServiceDetails[j].stockOut)
            // );
            this.disableBTN = true;
            break;
          }
        }
      }
    },

    addItem() {
      if (this.serviceDetails.serviceEstimationId != "") {
        this.itemModal["serviceEstimationId"] = this.serviceDetails.serviceEstimationId;
      } else {
        this.itemModal["serviceEstimationId"] = "";
      }
      this.validateModal();
      for (let j = 0; j < this.itemServiceDetails.length; j++) {
        if (this.itemServiceDetails[j].itemId == this.itemModal.itemId) {
          this.itemServiceDetails[j].itemQuantity = this.itemModal.itemQuantity;
        }
      }
      this.checkButtonDisable();

      if (this.validate != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/addServiceEstItem.php`,
          data: JSON.stringify(this.itemModal),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg != "Updated Successfully") {
                let array = this.itemDetail.filter((x, index) => {
                  return x.itemId != this.itemModal.itemId;
                });
                this.itemDetail = array;

                this.serviceDetails.itemForServiceEstId += data.Id + ",";
                this.alert.content = "Added Succesfully";
              } else {
                this.alert.content = "Data updated Succesfully";
              }
              Object.keys(this.itemModal).map((x) => {
                this.itemModal[x] = "";
              });
              this.itemNameError = "";
              this.itemCodeError = "";
              this.ratePerUnitError = "";
              this.itemQuantityError = "";
              this.onClose1();
            }
          })

          .catch((error) => {});
      }
    },

    viewRequiredItemList(serviceItemIds) {
      // console.log("Service item Ids", serviceItemIds);
      this.showServiceEst(serviceItemIds);
      this.showRequiredItemsList = true;
    },

    gobackToVehicleHistory() {
      this.showRequiredItemsList = false;
    },

    onClose1(type) {
      this.itemServiceDetails = [];
      let payload = {
        itemForServiceEstId: this.serviceDetails.itemForServiceEstId,
      };
      if (this.serviceDetails.serviceEstimationId != "") {
        payload["serviceEstimationId"] = this.serviceDetails.serviceEstimationId;
      } else {
        payload["serviceEstimationId"] = "";
      }

      console.log(payload);

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewServiceItem.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.itemArray.length > 0) {
              this.itemServiceDetails = data.itemArray;
            }

            this.itemServiceDetails.map((x, index) => {
              if (x.stockOutFlag == 0) {
                this.checked4.push({ value: false, id: x.itemForServiceEstId });
              } else {
                this.checked4.push({ value: true, id: x.itemForServiceEstId });
              }
            });

            (this.itemModal.itemCode = ""),
              (this.itemModal.itemName = ""),
              (this.itemModal.itemQuantity = ""),
              (this.itemModal.ratePerUnit = ""),
              (this.itemModal.remark = ""),
              (this.itemNameError = ""),
              (this.itemQuantityError = ""),
              (this.ratePerUnitError = "");
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },

    viewEditServiceEstimation() {
      let edit_SE = {
        editClient: "editClient",
        serviceEstimationId: this.$sessionsStorage.get("editServiceId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewEditServiceEst.php`,
        data: JSON.stringify(edit_SE),

        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            console.log(data);
            Object.keys(data.editClient[0]).map((x) => {
              this.serviceDetails[x] = data.editClient[0][x] || "";
              if (x == "vehicleTruckId") {
                this.serviceDetails["vehicleId"] = data.editClient[0][x] || "";
              } else if (x == "approvedStatus") {
                this.serviceDetails["requestStatus"] = data.editClient[0][x] || "";
              }
            });
            // if (
            //   (data.editClient[0].approvedBy == null ||
            //     data.editClient[0].approvedBy == "") &&
            //   this.$sessionsStorage.get("userLevel") == "1"
            // ) {
              this.serviceDetails.approvedBy = data.UserDetail[0].employeeName;
              this.serviceDetails.approvedById = data.UserDetail[0].userId;
            // }
            this.serviceDetails.itemForServiceEstId += ",";
            this.showServiceEst(this.serviceDetails.itemForServiceEstId);
          }
        })
        .catch((error) => {});
    },

    showServiceEst(serviceid) {
      this.itemServiceDetails = [];

      let payload = {
        itemForServiceEstId: serviceid,
        serviceEstimationId: "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewServiceItem.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.itemServiceDetails = data.itemArray;
            }

            this.itemServiceDetails.map((x, index) => {
              if (x.stockOutFlag == 0) {
                this.checked4.push({ value: false, id: x.itemForServiceEstId });
              } else {
                this.checked4.push({ value: true, id: x.itemForServiceEstId });
              }

              if (parseInt(x.itemQuantity) > parseInt(x.quantity)) {
                this.notValid = false;
                this.errorItem = x.itemName;
                return false;
              }
            });

            this.total = 0;
            this.itemServiceDetails.map((x, index) => {
              this.total = parseInt(x.totalAmount) + parseInt(this.total);
            });
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },

    itemMasterFilter(list, query) {
      return this.itemDetail.filter((x) => {
        return x.itemName.toLowerCase().includes(query.toLowerCase());
      });
    },
    finalAmount() {
      let amount =
        parseFloat(this.itemModal.ratePerUnit) * parseFloat(this.itemModal.itemQuantity);
      this.itemModal.totalAmount = amount;
    },

    vehicleMasterFilter(list, query) {
      return this.vehicleDetail.filter((x) => {
        return x.regdNo.toLowerCase().includes(query.toLowerCase());
      });
    },

    locationMasterFilter(list, query) {
      return this.locationMaster.filter((x) => {
        return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
      });
    },
    containerMasterFilter(list, query) {
      return this.containerDetail.filter((x) => {
        return x.containerType.toLowerCase().includes(query.toLowerCase());
      });
    },

    employeeMasterFilter(list, query) {
      return this.employeeMaster.filter((x) => {
        return x.employeeName.toLowerCase().includes(query.toLowerCase());
      });
    },

    previousVendorView() {
      this.$router.push({
        path: "/serviceEstimation/viewServiceEstimation",
      });
    },

    addServiceEst(requestStatus) {
      if (
        this.$sessionsStorage.get("editServiceId") != "" &&
        this.$sessionsStorage.get("editServiceId") != undefined
      ) {
        // this.serviceDetails["updateStatus"] = this.checked4;
        this.serviceDetails["designation"] = this.designation;
        this.serviceDetails["userLevel"] = this.userLevel;
      }

      this.serviceDetails["approvalSent"] = requestStatus;
      this.serviceDetails["PS_save_subItemList"] = this.PS_save_subItemList;

      this.validateJobOrder();
      console.log("this.serviceDetails=>",this.serviceDetails);
      // return false;
      if (this.validate != false) {
        if (requestStatus == "Pending") {
          $("#addButtonLoader").css("display", "none");
          $("#loader").css("display", "block");
        } else {
          $("#addButtonLoader1").css("display", "none");
          $("#loader1").css("display", "block");
        }
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/addServiceEstimationPS.php`,
          data: JSON.stringify(this.serviceDetails),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (requestStatus == "Pending") {
                $("#addButtonLoader").css("display", "none");
                $("#loader").css("display", "block");
                this.$refs["addPop3"].open();
              } else {
                $("#addButtonLoader1").css("display", "none");
                $("#loader1").css("display", "block");
                this.$refs["addPop4"].open();
                this.alert.content = "Sent For Approval";
              }
            }
          })
          .catch((error) => {});
      }
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  margin-top: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
  border: 0px;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.success {
  color: green;
}
.warning {
  color: orangered;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 1;
}
.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 50%;
  height: 50%;
}
.md-select-content {
  z-index: 999999999;
}
.back {
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// serviceEstimation.vue?8048ee92